import { getBuyerId } from 'dibs-cookie-jar';
import SV from 'server-vars';

import isPageType from '../../../utils/isPageType';
import { PAGE_TYPE } from '../../../utils/pageConstants';

import { fetchQuery, graphql } from 'react-relay';
import getter from 'dibs-object-getter';

const VALID_PROGRAMS = ['BRONZE', 'SILVER', 'GOLD', 'PLATINUM'];
const query = graphql`
    query tradeRewardsLevelUpModalRule_Query($userId: String!) {
        viewer {
            user(userId: $userId) {
                tradeFirm {
                    rewards {
                        currentProgram {
                            programInfo {
                                code
                            }
                        }
                    }
                }
                activityFeed(first: 1, elementTypes: [TRADE_REWARD_PROGRAM]) {
                    edges {
                        node {
                            serviceId
                            type
                            status
                        }
                    }
                }
            }
        }
    }
`;

function queryIsLevelledUp(userId, relayEnvironment) {
    return fetchQuery(relayEnvironment, query, { userId }).then(data => {
        const currentProgram = getter(data)
            .at('viewer')
            .at('user')
            .at('tradeFirm')
            .at('rewards')
            .at('currentProgram')
            .at('programInfo')
            .value('code');
        const latestLevelUp =
            getter(data)
                .at('viewer')
                .at('user')
                .at('activityFeed')
                .at('edges')
                .at(0)
                .value('node') || {};

        return (
            VALID_PROGRAMS.includes(currentProgram) &&
            latestLevelUp.type === 'TRADE_REWARD_PROGRAM' &&
            latestLevelUp.status === 'ACTIVE'
        );
    });
}

export function tradeRewardsLevelUpModalRule({ relayEnvironment, forceNotification }) {
    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;
    const isMobile = SV.get('settings.isMobile') || false;
    const isBlacklistedPage = isPageType([
        PAGE_TYPE.CHECKOUT,
        PAGE_TYPE.CHECKOUT_CONFIRMATION,
        PAGE_TYPE.ORDER_MANAGER,
        PAGE_TYPE.TRADE_REWARDS,
    ]);
    const userId = getBuyerId(document.cookie);
    if (!userId || !isUserTypeTrade || isMobile || isBlacklistedPage) {
        return Promise.resolve(false);
    }

    if (forceNotification) {
        return Promise.resolve(true);
    }

    return queryIsLevelledUp(userId, relayEnvironment);
}
